import React, { useState, Fragment, useEffect } from 'react';
import { Button, Card, CardBody, Input, Label } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import UploadFile from './UploadFile';  // Ensure this is the correct path
import { ExtFile } from '@dropzone-ui/react';
import { PageFile } from './ReportCreator';
import VideoRecorder from './VideoRecorder';

interface ElementPropertiesProps {
  element: Element | null;
  elements: Element[];
  setElements: (elements: Element[]) => void;
  setSelectedElement: (element: Element | null) => void;
  onUpdate: (updatedElement: any) => void;
  pageFiles: PageFile[];
  setPageFiles: (files: PageFile[]) => void;
}

interface Element {
  id: number;
  type: string;
  subject: string;
  description: string;
  file_id?: string;
}

const ElementProperties: React.FC<ElementPropertiesProps> = ({
  element, elements, setElements, setSelectedElement, onUpdate, pageFiles, setPageFiles
}) => {

  const handleChange = (key: string, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value } = e.target;
    onUpdate({ ...element, [key]: value });
  };

  const [pageFile, setPageFile] = useState<any>(element?.file_id ? pageFiles.find(f => f.id === element?.file_id) : { id: 0, file: null })

  const handleRemove = () => {
    const newElements = elements.filter(e => e.id !== element?.id);
    setElements(newElements);
    setSelectedElement(null);
  };

  useEffect(() => {
    setPageFile(element?.file_id ? pageFiles.find(f => f.id === element?.file_id) : { id: 0, file: null })
  }, [element])

  useEffect(() => {
    if (pageFile?.file) {
      if (!pageFiles.find((f: any) => f.id === pageFile?.id)) {
        setPageFiles([...pageFiles, pageFile])
        onUpdate({ ...element, "file_id": pageFile.id });
      }
    }
    else {
      if (element?.file_id) {
        setPageFiles(pageFiles.filter((v: any) => v.id !== element?.file_id))
        onUpdate({ ...element, "file_id": 0 });
      }
    }
  }, [pageFile])

  return (
    <div>
      <Card style={{ overflow: "auto", width: '250px', maxHeight: "calc(100vh - 320px)" }}>
        <CardBody>
          <H5 className="mb-3">Element Properties</H5>
          {element?.type === 'dropdown' && (
            <Fragment>
              <div className="mb-3">
                <Label className="col-form-label mb-0">{"Subject"}</Label>
                <Input
                  type="text"
                  onChange={(e: any) => handleChange("subject", e)}
                  placeholder="Subject"
                  value={element.subject || ''}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <Label className="col-form-label mb-0">{"Description"}</Label>
                <Input
                  type="textarea"
                  onChange={(e: any) => handleChange("description", e)}
                  placeholder="Description"
                  value={element.description || ''}
                  className="form-control"
                />
              </div>
            </Fragment>
          )}
          {element?.type === 'text' && (
            <Fragment>
              <div className="mb-3">
                <Label className="col-form-label mb-0">{"Description"}</Label>
                <Input
                  type="textarea"
                  onChange={(e: any) => handleChange("description", e)}
                  placeholder="Description"
                  value={element.description || ''}
                  className="form-control"
                />
              </div>
            </Fragment>
          )}
          {(element?.type === 'video' || element?.type === 'image') && (
            <UploadFile pageFiles={pageFiles} filetype={element?.type} elementFileId={element?.file_id || ""} setPageFiles={setPageFiles} pageFile={pageFile} setPageFile={setPageFile} />
          )}

          {(element?.type === 'video') && !pageFile?.file && (
            <VideoRecorder setPageFile={setPageFile} />
          )}

          <Button color="danger" onClick={handleRemove}>Remove</Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default ElementProperties;
